export default __webpack_public_path__ + "static/media/simple-center-email.46ad2eb0.jpg";